// extracted by mini-css-extract-plugin
export default {"container":"Container_container__ITA5v","min-height":"Container_min-height__hiEM2","start":"Container_start__maF5V","column":"Container_column__6cgaW"};